import { render, staticRenderFns } from "./TabCard.vue?vue&type=template&id=ea0889ce&scoped=true"
import script from "./TabCard.vue?vue&type=script&lang=js"
export * from "./TabCard.vue?vue&type=script&lang=js"
import style0 from "./TabCard.vue?vue&type=style&index=0&id=ea0889ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0889ce",
  null
  
)

export default component.exports